import "./Ball.css";

export default function Ball({ isItAfterShot, moveBallTo }) {
    return <div className={`ball${isItAfterShot ? " " + moveBallTo : ""}`}></div>;
}
